import {
  SET_TIN_CHAP_EDIT,
  SET_CONFIG_TM_TIN_CHAP,
  SHOW_FORM_TIN_CHAP,
  GET_CONFIG_SYS_TMTC,
  POST_TIN_CHAP,
  POST_TIN_CHAP_SUCCESS,
  POST_TIN_CHAP_FAILURE,
  CHECK_EDIT_TIN_CHAP,
  CHECK_EDIT_CUSTOMER_TC,
  SET_ENABLE_EDIT_TIN_CHAP,
  SET_ENABLE_EDIT_CUSTOMER_TC,
  SET_TAI_SAN_TC,
  GET_TAI_SAN_THEO_CHO_VAY_TMTC,
} from 'actions/ThemMoiTinChap/actionTypes';

const initialState = {
  choVayEdit: {
    NgayVay: new Date(),
    CustomerId: 0,
    IsEditChoVay: true,
    IsEditCustomer: true,
  },
  ConfigTMCD: {},
  isShowFormTinChap: false,
  postTinChapLoading: false,
  postTinChapReturn: false,
  TaiSanTinChap: {},
};
const setTaiSanTinChap = (state, action) => ({
  ...state,
  TaiSanTinChap: action.payload,
});
const setChoVayEdit = (state, action) => ({
  ...state,
  choVayEdit: action.payload,
});

const setConfig = (state, action) => {
  let config = action.payload;
  let choVayEdit = state.choVayEdit;
  if (!choVayEdit.ChoVayId) {
    choVayEdit.TypePaid = config._selectKyDongLai;
    let _selectKyDongLai = parseFloat(action.payload._selectKyDongLai);
    if (_selectKyDongLai === 1) {
      choVayEdit.KieuLaiSuat = config._selectKyLaiSuatNgay;
      choVayEdit.LaiSuat = config._laiSuatTinChapCamDoNgay;
    } else if (_selectKyDongLai === 2) {
      choVayEdit.LaiSuat = config._laiSuatTinChapCamDoThang;
      choVayEdit.KieuLaiSuat = config._selectKyLaiSuatThang;
    } else if (_selectKyDongLai === 4) {//Tuần
      choVayEdit.KieuLaiSuat = config._selectKyLaiSuatTuan;
      choVayEdit.LaiSuat = config._laiSuatTinChapCamDoTuan;
    }
    else {
      choVayEdit.LaiSuat = '';
    }
    choVayEdit.CountTypePaid = config._kyDongLaiTinChapCamDo;
    choVayEdit.BeforeAfter =
      action.payload._beforeAfterTinChapCamDo === '1' ? '2' : '1';
    if (config.IsSoNgayTatToan)
      choVayEdit.SoNgayToiThieu = config.SoNgayMacDinhTatToan;
    else
      choVayEdit.SoNgayToiThieu = 0;

  }
  return {
    ...state,
    choVayEdit,
    ConfigTMCD: action.payload,
  };
};
const showFormTinChap = (state, action) => {
  let choVay = {
    NgayVay: new Date(),
    CustomerId: 0,
  };
  if (action.payload && action.payload.ChoVayId) {
    choVay = action.payload;
  }
  choVay.IsEditChoVay = true;
  choVay.IsEditCustomer = true;
  return {
    ...state,
    choVayEdit: choVay,
    isShowFormTinChap: !state.isShowFormTinChap,
  };
};
const getConfigSysTMTC = (state, action) => ({
  ...state,
});

const postTinChap = (state, action) => ({
  ...state,
  postTinChapLoading: true,
  postTinChapReturn: false,
  dataPost: action.dataPost,
});

const postTinChapSuccess = (state, action) => {
  let choVayEdit = state.choVayEdit;
  choVayEdit.ChoVayId = action.payload.ChoVayId;
  choVayEdit.showButtonIn = true;
  choVayEdit.ThuChiId = action.payload.ThuChiId;
  choVayEdit.ImgDinhKemSave = action.payload.ImgDinhKem;
  choVayEdit.lstImgTaiSanSave = action.payload.lstImgTaiSan;
  choVayEdit.ImgCusNewSave = action.payload.ImgKhachHang;
  choVayEdit.Code = action.payload.Code;
  if (parseFloat(choVayEdit.BeforeAfter) === 2) {
    choVayEdit.showButtonInPhieuThu = true;
  }
  return {
    ...state,
    postTinChapLoading: false,
    postTinChapReturn: true,
    choVayEdit,
  };
};

const postTinChapFailed = (state, action) => ({
  ...state,
  postTinChapLoading: false,
  postTinChapReturn: false,
});
const checkEditChoVay = (state, action) => ({
  ...state,
});
const setEnableEditChoVay = (state, action) => {
  let choVayEdit = state.choVayEdit;
  choVayEdit.IsEditChoVay = action.payload.IsEditChoVay;
  choVayEdit.IsEditCustomer = action.payload.IsEditCustomer;
  return {
    ...state,
    choVayEdit,
  };
};
const checkEditCustomer = (state, action) => ({
  ...state,
});
const setEnableEditCustomer = (state, action) => {
  let choVayEdit = state.choVayEdit;
  choVayEdit.IsEditCustomer = action.payload.IsEditCustomer;
  return {
    ...state,
    choVayEdit,
  };
};
const getTaiSanTheoChoVayTMTC = (state, action) => ({
  ...state,
});
const themMoiTinChapReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TIN_CHAP_EDIT:
      return setChoVayEdit(state, action);
    case SET_CONFIG_TM_TIN_CHAP:
      return setConfig(state, action);
    case SHOW_FORM_TIN_CHAP:
      return showFormTinChap(state, action);
    case GET_CONFIG_SYS_TMTC:
      return getConfigSysTMTC(state, action);
    case POST_TIN_CHAP:
      return postTinChap(state, action);
    case POST_TIN_CHAP_SUCCESS:
      return postTinChapSuccess(state, action);
    case POST_TIN_CHAP_FAILURE:
      return postTinChapFailed(state, action);
    case CHECK_EDIT_TIN_CHAP:
      return checkEditChoVay(state, action);
    case SET_ENABLE_EDIT_TIN_CHAP:
      return setEnableEditChoVay(state, action);
    case CHECK_EDIT_CUSTOMER_TC:
      return checkEditCustomer(state, action);
    case SET_ENABLE_EDIT_CUSTOMER_TC:
      return setEnableEditCustomer(state, action);
    case SET_TAI_SAN_TC:
      return setTaiSanTinChap(state, action);
    case GET_TAI_SAN_THEO_CHO_VAY_TMTC:
      return getTaiSanTheoChoVayTMTC(state, action);
    default:
      return state;
  }
};
export default themMoiTinChapReducer;
